import { forwardRef } from 'react'

import { TextFieldProps } from '@mui/material/TextField'

import { CustomTextField } from 'src/@core/components/mui/text-field'

type DatePickerCustomInputProps = TextFieldProps & {
  label?: string
  error?: boolean
  registername?: string
}

export const DatePickerCustomInput = forwardRef(({ ...props }: DatePickerCustomInputProps, ref) => {
  return (
    <CustomTextField
      inputRef={ref}
      fullWidth
      {...props}
      label={props.label || ''}
      sx={{ width: '100%' }}
      error={props.error}
    />
  )
})
